import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'
import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import {
  getFormattedPromotionDiscountedAmountOrPercentage,
  ProductSellerVoucherLabelDiscountDialog,
} from '../../../../product'
import { ProductSearchFlag } from '../../ProductSearchFlag'

type ProductSearchItemOfferDiscountFlagProps = {
  sellerPromotion: SellerPromotionV2
}

export const ProductSearchItemOfferDiscountFlag: FC<
  ProductSearchItemOfferDiscountFlagProps
> = ({ sellerPromotion }) => {
  const modalControls = useOpenableControls()
  const intl = useIntl()

  return (
    <>
      <ProductSearchFlag
        className="bg-light-tertiary hover:bg-light-hover-tertiary active:bg-light-pressed-tertiary"
        onClick={modalControls.handleOpen}
        slots={{ root: 'button' }}
        type="button"
      >
        <FormattedMessage
          id="seller.promotion.product.discount.withCode"
          values={{
            discountPercent: getFormattedPromotionDiscountedAmountOrPercentage(
              sellerPromotion,
              intl,
            ),
          }}
        />
        <IconInfo className="ml-1 size-4" />
      </ProductSearchFlag>
      <ProductSellerVoucherLabelDiscountDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
        sellerPromotion={sellerPromotion}
      />
    </>
  )
}
